import { useLead } from "@/context/LeadContext";
import Icon from "@/components/Icon";

export default function CTASection() {
  const { openLead } = useLead();
  return (
    <section className="cta" id="cta" data-testid="cta-section">
      <img src="/assets/cta-family.png" alt="Family walking toward a brighter tomorrow" className="cta__bg" />
      <div className="container cta__inner">
        <div className="cta__copy">
          <h2 className="cta__title display">Care Forward. Always Proactive.</h2>
          <p className="cta__text">Build a healthier tomorrow with the PUMS ecosystem.</p>
        </div>
        <div className="cta__actions">
          <button className="btn btn--green" onClick={() => openLead("demo")} data-testid="cta-request-demo">
            Request a Demo <Icon name="ArrowRight" size={16} />
          </button>
          <button className="btn btn--outline-dark" onClick={() => openLead("contact")} data-testid="cta-contact">
            <Icon name="Mail" size={16} /> Contact Our Team
          </button>
        </div>
        <span className="cta__watermark">People<br/>Technology<br/>Better Tomorrows</span>
      </div>
    </section>
  );
}
